import Cookies from 'js-cookie';

export interface QuotaData {
    uuid: string;
    checkoutUrl: string;
    hotelName: string;
    hotelCover: string;
    countryName: string;
    resortName: string;
}

export function useQuotaCookie() {
    const setQuotaCookie = (data: QuotaData, domain: string) => {
        const expires = new Date(Date.now() + 96 * 60 * 60 * 1000);

        try {

            Cookies.set('quotaInfo', JSON.stringify(data), {
                expires,
                secure: true,
                domain: domain,
                path: '/'
            });
        } catch (error) {
            console.error('Error setting cookie:', error);
        }
    };

    const removeQuotaCookie = (domain?: string) => {
        try {
            if (domain) {
                Cookies.remove('quotaInfo', { path: '/', domain: domain });
                if (!domain.startsWith('.')) {
                    Cookies.remove('quotaInfo', { path: '/', domain: `.${domain}` });
                }
            }
            Cookies.remove('quotaInfo', { path: '/' });
        } catch (e) {
            console.error('Error removing cookie:', e);
        }
    };

    return {
        setQuotaCookie,
        removeQuotaCookie,
    };
}